// API-Layer fuer die Geraete-Verwaltung. Single-Source-of-Truth-Liste
// liegt im Backend; das FE haelt nur eine lazy geladene Kopie.

import { deleteJSON, getJSON, patchJSON, postJSON } from "./api";

export interface DeviceView {
  id: number;
  name: string;
  user_agent: string;
  first_seen_at: string;
  last_seen_at: string;
  last_ip: string;
  last_location?: string;
  can_approve_push: boolean;
  is_current: boolean;
}

// formatBrowser extrahiert "Firefox 150" o.ae. aus dem User-Agent-String.
// Wenn nichts zu erkennen ist, liefert es leer zurueck (Caller soll dann
// keine Browser-Zeile zeigen). Heuristik ist absichtlich knapp -- ein
// vollstaendiger UA-Parser kostet Bundle-KB und brauchen wir nicht.
export function formatBrowser(ua: string | undefined | null): string {
  if (!ua) return "";
  // Edge muss VOR Chrome/Safari geprueft werden -- der UA-String enthaelt
  // beides. Reihenfolge ist also nicht alphabetisch, sondern nach
  // Spezifizitaet.
  const order: Array<[RegExp, string]> = [
    [/Edg\/(\d+)/, "Edge"],
    [/Firefox\/(\d+)/, "Firefox"],
    [/Chrome\/(\d+)/, "Chrome"],
    [/Version\/(\d+).+Safari\//, "Safari"],
    [/curl\/(\d+)/, "curl"],
  ];
  for (const [re, name] of order) {
    const m = ua.match(re);
    if (m) return `${name} ${m[1]}`;
  }
  return "";
}

export async function listDevices(): Promise<DeviceView[]> {
  return getJSON<DeviceView[]>("/v2-api/devices");
}

export async function renameDevice(id: number, name: string): Promise<DeviceView> {
  return patchJSON<DeviceView>(`/v2-api/devices/${id}`, { name });
}

export async function setDevicePushApproval(id: number, allowed: boolean): Promise<DeviceView> {
  return patchJSON<DeviceView>(`/v2-api/devices/${id}`, {
    can_approve_push: allowed,
  });
}

export async function revokeDevice(id: number): Promise<void> {
  await deleteJSON<{ ok: true }>(`/v2-api/devices/${id}`);
}

export async function markDeviceCompromised(id: number): Promise<void> {
  await postJSON<{ ok: true }>(`/v2-api/devices/${id}/mark-compromised`);
}

export async function revokeAllOtherDevices(): Promise<void> {
  await postJSON<{ ok: true }>("/v2-api/devices/revoke-all-others");
}

// reorderDevices persistiert eine komplette neue Reihenfolge. Backend
// erwartet alle aktiven Geraete-IDs des Users genau einmal -- partielle
// Listen schlagen mit 400 fehl.
export async function reorderDevices(ids: number[]): Promise<void> {
  await postJSON<{ ok: true }>("/v2-api/devices/reorder", { ids });
}
